import { cn } from "../../utils/cn";
import { Icon } from "@iconify/react";

export function Badge({ icon, label, leading, className, style }) {
    const defaultStyle = {
        backgroundColor: '#DBF5FF',
        color: '#06B6D4',
        borderColor: '#06B6D4',
    };
    
    const mergedStyle = { ...defaultStyle, ...style };
    const iconColor = mergedStyle.color;
    
    return (
        <div
            className={cn(
                "inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-medium border",
                className
            )}
            style={mergedStyle}
        >
            {leading && icon && <Icon icon={icon} className="size-4" style={{ color: iconColor }} />}
            {label}
            {!leading && icon && <Icon icon={icon} className="size-4" style={{ color: iconColor }} />}
        </div>
    );
}
